/** Rows and the date of agenda content (or its card), shared by the frame and its card preview. */

export interface AgendaItem {
  id: string;
  time: string;
  title: string;
  detail?: string;
  current?: boolean;
}

export function toAgendaItems(value: unknown): AgendaItem[] | undefined {
  if (!Array.isArray(value)) return undefined;
  const items: AgendaItem[] = [];
  for (const raw of value) {
    if (typeof raw !== "object" || raw === null) continue;
    const row = raw as Record<string, unknown>;
    if (typeof row.id !== "string" || typeof row.title !== "string") continue;
    items.push({
      id: row.id,
      time: typeof row.time === "string" ? row.time : "",
      title: row.title,
      detail: typeof row.detail === "string" ? row.detail : undefined,
      current: row.current === true,
    });
  }
  return items;
}

const DAY_NUMBER = /\b(\d{1,2})\b/;
const WEEKDAY = /\b(mon|tue|wed|thu|fri|sat|sun)[a-z]*\b/i;

/** The day number and short weekday a free-text date names, if any. */
export function dateParts(date: string | null): {
  day: string | null;
  weekday: string | null;
} {
  return {
    day: date ? (DAY_NUMBER.exec(date)?.[1] ?? null) : null,
    weekday: date ? (WEEKDAY.exec(date)?.[1]?.toUpperCase() ?? null) : null,
  };
}
